import React from 'react';
import { LoggerFactory } from '@ibe/services';
import { ApiRole } from '@ibe/api';
import Page from './Models/Page';
import MasterData from './Pages/MasterData';
import PageUrl from './Models/PageUrl';
import AudioData from './Pages/AudioData';
import Login from './Pages/Login';
import Logout from './Pages/Logout/Logout';
import CharityData from './Pages/CharityData';

const logger = LoggerFactory.get('pages');

export const pages: Record<PageUrl, Page> = {
  [PageUrl.LOGIN]: {
    component: <Login />
  },
  [PageUrl.LOGOUT]: {
    component: <Logout />,
    requiredRoles: [ApiRole.AGENT],
    redirectTo: PageUrl.LOGIN
  },
  [PageUrl.AUDIODATA]: {
    component: <AudioData />,
    requiredRoles: [ApiRole.AGENT],
    redirectTo: PageUrl.LOGIN
  },
  [PageUrl.HOME]: {
    component: <MasterData />,
    requiredRoles: [ApiRole.AGENT],
    redirectTo: PageUrl.LOGIN
  },
  [PageUrl.CHARITYDATA]: {
    component: <CharityData />,
    requiredRoles: [ApiRole.AGENT],
    redirectTo: PageUrl.LOGIN
  }
};

export const getPageByUrl = (url: PageUrl | string): Page => {
  if (Object.prototype.hasOwnProperty.call(pages, url)) {
    return pages[url as PageUrl];
  }
  logger.error(`No page found for url ${url}`);
  return pages[PageUrl.HOME];
};
